export const HEADER = 'Settings';
export const BILLING = 'Billing';
export const AFFILIATES = 'Referrals';
export const USERS = 'Users';
export const COMPANY = 'Company';
export const MY_ACCOUNT = 'My Account';
export const GREATFULL_MESSAGE =
  'Thanks for upgrading to MobileMonkey Operator!';
export const SUCCESS_MESSAGE =
  'Success! This code has been applied to your facebook page!';
export const ERROR_MESSAGE =
  'Sorry, that product code is invalid. Please contact';
export const MISTAKE_MESSAGE = 'if you think this is a mistake';
export const QUESTIONS = 'Questions about your subscription?';
export const ANSWER =
  'with any questions or concerns regarding the information on this page';
export const PRO_NOTE = `
  takes your campaigns to the next level with Messenger automation and integrates
  your Contact data across your Marketing stack
`;
export const CANCEL_MESSAGE = 'Cancel month-to-month subscription';
export const CANCEL_NOTE =
  'Are you sure? We hate to see you go! Please tell us why you’re leaving:';
export const CANCELED_MESSAGE = (email: string) =>
  `Thank you. A member of our Customer Success team will contact you shortly at
  ${email} to complete the downgrade process. You will not be charged again.`;
export const REMAIN_MESSAGE = `Please note: Introductory coupons and promotions cannot
  be redeemed on Facebook Pages with canceled subscriptions.`;
